import { render, staticRenderFns } from "./DigitalSignage.vue?vue&type=template&id=1bf0ee9c&"
import script from "./DigitalSignage.vue?vue&type=script&lang=js&"
export * from "./DigitalSignage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports